export const METRICS = {
  NUMBER_OF_PAYMENTS: 'numberOfPayments',
  NUMBER_OF_BOOKINGS: 'numberOfBookings',
  NUMBER_OF_SUBSCRIPTIONS: 'numberOfSubscriptions',
  NUMBER_OF_SUBMISSIONS: 'numberOfSubmissions',
  REVENUE: 'revenue',
  NUMBER_OF_CUSTOMERS: 'numberOfCustomers',
  NUMBER_OF_VISITS: 'numberOfVisits',
  ACTIVE_SUBSCRIBERS: 'activeSubscribers',
  RECURRING_REVENUE: 'recurringRevenue',
  NUMBER_OF_ABANDONED_CARTS: 'numberOfAbandonedCarts',
  NUMBER_OF_RECOVERED_CARTS: 'numberOfRecoveredCarts',
  RECOVERED_REVENUE: 'recoveredRevenue',
  NUMBER_OF_RECOVERY_EMAILS_SENT: 'numberOfRecoveryEmailsSent',
};
